export const myColor = {
    buttonColor:'#265073',
    backgroundColor: '#f6f8ff',
    detailBackground:'#fff7eb',
    secondaryColor:'#B4B4B8',
    dangerColor: '#8E1616',
}